import { useParams, Link } from "react-router-dom";
import "../styles/projLoginPage.css";

const STATES = {
  success: {
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
      </svg>
    ),
    iconClass: "fp-icon-success",
    title: "Account activated!",
    body: "Your account is now active. You can sign in and start playing.",
    action: <Link className="lp-submit" style={{ display: "block", textAlign: "center", marginTop: "1.5rem" }} to="/projLoginPage">Sign In</Link>,
  },
  expired: {
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    iconClass: "fp-icon-warn",
    title: "Link expired",
    body: "This activation link has expired (links are valid for 24 hours). Please register again to receive a new one.",
    action: <Link className="lp-submit" style={{ display: "block", textAlign: "center", marginTop: "1.5rem" }} to="/register">Register again</Link>,
  },
  invalid: {
    icon: (
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    ),
    iconClass: "fp-icon-error",
    title: "Invalid link",
    body: "This activation link is not valid or has already been used.",
    action: <Link className="lp-submit" style={{ display: "block", textAlign: "center", marginTop: "1.5rem" }} to="/projLoginPage">Back to Sign In</Link>,
  },
};

export default function ActivateAccountPage() {
  const { status } = useParams();
  const view = STATES[status] || STATES.invalid;

  return (
    <div className="lp-container">
      <div className="lp-card">
        <div className="fp-status">
          <div className={`fp-status-icon ${view.iconClass}`}>{view.icon}</div>
          <h2 className="lp-title">{view.title}</h2>
          <p className="lp-subtitle" style={{ textAlign: "center", maxWidth: 320 }}>{view.body}</p>
          {view.action}
        </div>
      </div>
    </div>
  );
}
